/* KFH collection page: sort, filters dialog, grid size and photo style (remembered per visitor),
   smooth jumps to groups, About text toggle, bundle guide dialog. */
(() => {
  const store = {
    get: (k) => { try { return localStorage.getItem(k); } catch (e) { return null; } },
    set: (k, v) => { try { localStorage.setItem(k, v); } catch (e) { /* storage blocked */ } },
  };

  const init = (root) => {
    if (!root || root.dataset.ready) return;
    root.dataset.ready = '1';

    // Sort: reload with sort_by, keeping the current filters.
    const sort = root.querySelector('[data-kfh-sort]');
    if (sort) sort.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', sort.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });

    // Dialogs (native <dialog>: Escape and focus handling come built in).
    const wire = (openSel, dialogSel, closeSel) => {
      const dialog = root.querySelector(dialogSel);
      if (!dialog) return;
      root.querySelectorAll(openSel).forEach((b) => b.addEventListener('click', () => dialog.showModal()));
      dialog.querySelectorAll(closeSel).forEach((b) => b.addEventListener('click', () => dialog.close()));
      dialog.addEventListener('click', (e) => { if (e.target === dialog) dialog.close(); });
    };
    wire('[data-kfh-filters-open]', '[data-kfh-filters]', '[data-kfh-filters-close]');
    // Leave empty price boxes out of the URL.
    const filterForm = root.querySelector('.kfh-filters__form');
    if (filterForm) filterForm.addEventListener('submit', () => {
      filterForm.querySelectorAll('input[type="number"]').forEach((i) => { if (!i.value) i.disabled = true; });
    });
    wire('[data-kfh-guide-open]', '[data-kfh-guide]', '[data-kfh-guide-close]');

    // Grid size: 2-up / 1-up on mobile, default / denser on desktop.
    const dense = root.querySelector('[data-kfh-density]');
    const applyDense = (on) => { root.classList.toggle('is-dense', on); if (dense) dense.setAttribute('aria-pressed', String(on)); };
    applyDense(store.get('kfh-coll-dense') === '1');
    if (dense) dense.addEventListener('click', () => {
      const on = !root.classList.contains('is-dense');
      applyDense(on);
      store.set('kfh-coll-dense', on ? '1' : '0');
    });

    // On model / Close-up.
    const views = root.querySelectorAll('[data-kfh-view]');
    const applyView = (v) => {
      root.classList.toggle('is-closeup', v === 'closeup');
      views.forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.kfhView === v)));
    };
    if (views.length) {
      applyView(store.get('kfh-coll-view') || 'model');
      views.forEach((b) => b.addEventListener('click', () => { applyView(b.dataset.kfhView); store.set('kfh-coll-view', b.dataset.kfhView); }));
    }

    // Type rail on texture pages jumps to its group under the sticky header.
    root.querySelectorAll('[data-kfh-jump]').forEach((a) => a.addEventListener('click', (e) => {
      const target = document.querySelector(a.getAttribute('href'));
      if (!target) return;
      e.preventDefault();
      const header = document.querySelector('.kfh-header-section');
      const offset = (header ? header.getBoundingClientRect().height : 0) + 13;
      window.scrollTo({ top: target.getBoundingClientRect().top + window.scrollY - offset, behavior: 'smooth' });
    }));

    // Type rail without a server-side type filter: show/hide the loaded cards.
    const typeLinks = root.querySelectorAll('[data-kfh-type]');
    if (typeLinks.length) {
      const count = root.querySelector('[data-kfh-count]');
      typeLinks.forEach((a) => a.addEventListener('click', (e) => {
        e.preventDefault();
        const type = a.dataset.kfhType;
        let shown = 0;
        root.querySelectorAll('[data-kfh-results] li[data-type]').forEach((li) => {
          li.hidden = !!type && li.dataset.type !== type;
          if (!li.hidden) shown += 1;
        });
        root.querySelectorAll('.kfh-coll__tile, .kfh-edit--tile').forEach((t) => { t.hidden = !!type; });
        typeLinks.forEach((l) => l.classList.toggle('is-on', l === a));
        if (count) { const line = count.dataset.template.replace('[count]', shown); count.textContent = shown === 1 ? line.replace('products', 'product') : line; }
      }));
    }

    // About text: two lines, Read more / Read less. Hide the toggle when it all fits.
    const seo = root.querySelector('[data-kfh-seo]');
    if (seo) {
      const text = seo.querySelector('.kfh-coll__seo-text');
      const btn = seo.querySelector('[data-kfh-seo-toggle]');
      if (text.scrollHeight <= text.clientHeight + 2) btn.hidden = true;
      btn.addEventListener('click', () => {
        const open = seo.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', String(open));
        btn.textContent = open ? btn.dataset.less : btn.dataset.more;
      });
    }
  };

  const boot = () => document.querySelectorAll('[data-kfh-coll]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
